import {
    ProductType,
    SerializationType,
    ServicePackageAddon,
    ServicePackageType,
} from '@/api/Cart/cart.interfaces';
import { getBaselineLinkUrl } from './ServicePackage.helpers';
import { ServicePackageName } from '@ui/components/ServicePackage/ServicePackage.interfaces';
import { getMoneyObjectAsString } from '@shared/helpers/money';
import store from '@/store';

export const RECOMMENDED_SERVICE_PACKAGE = ServicePackageName.Basic;

export const BASELINE_SERVICE_PACKAGE: ServicePackageAddon = {
    Id: 'f779f587-c41f-49d5-aeee-1e1b4c079f2d',
    $type: SerializationType.ServicePackage,
    Type: ProductType.Addon,
    Description: '',
    Price: {
        Amount: 0,
        Currency: 'EUR',
    },
    OriginalPrice: null,
    get LinkUrl() {
        return getBaselineLinkUrl();
    },
    ShowDiscardPopUp: false,
    Ordinal: ServicePackageType.None,
    AppliedDiscount: null,
    Tags: ['ShowOnCheckoutPage'],
};

export function getPostBookingPricePerMarket() {
    const market = store.getters['general/getMarket'];

    switch (market.number) {
        // Scandinavian markets
        case 1:
        case 101:
            return getMoneyObjectAsString({ Amount: 299, Currency: 'SEK' });
        case 4:
        case 104:
            return getMoneyObjectAsString({ Amount: 299, Currency: 'NOK' });
        case 5:
        case 105:
        case 405:
            return getMoneyObjectAsString({ Amount: 299, Currency: 'DKK' });

        // UK
        case 10:
        case 110:
            return getMoneyObjectAsString({ Amount: 29, Currency: 'GBP' });

        // Eurozone countries - EUR
        case 6: // Finland
        case 7: // Germany
        case 9: // Netherlands
        case 11: // Ireland
        case 12: // Austria
        case 13: // Hungary
        case 20: // Spain
        case 21: // Portugal
        case 24: // Bulgaria
        case 25: // Czech Republic
        case 41: // Belgium
        case 43: // Romania
        case 47: // Slovakia
        case 52: // Switzerland
        case 53: // Greece
        case 62: // Estonia
        case 63: // France
        case 64: // Iceland
        case 66: // Italy
        case 71: // Luxembourg
        case 72: // Malta
        case 106: // Finland (Stena)
        case 107: // Germany (Stena)
        case 109: // Netherlands (Stena)
        case 111: // Ireland (Stena)
            return getMoneyObjectAsString({ Amount: 29, Currency: 'EUR' });

        // Poland - PLN
        case 8:
        case 108:
            return getMoneyObjectAsString({ Amount: 115, Currency: 'PLN' });

        case 14: // Australia
            return getMoneyObjectAsString({ Amount: 45, Currency: 'AUD' });
        case 15: // New Zealand
            return getMoneyObjectAsString({ Amount: 50, Currency: 'NZD' });
        case 16: // North America
            return getMoneyObjectAsString({ Amount: 35, Currency: 'USD' });
        case 17: // Canada
            return getMoneyObjectAsString({ Amount: 35, Currency: 'CAD' });
        case 18: // South Africa
            return getMoneyObjectAsString({ Amount: 450, Currency: 'ZAR' });
        case 19: // Singapore
            return getMoneyObjectAsString({ Amount: 40, Currency: 'SGD' });

        // Other major markets
        case 26: // India
            return getMoneyObjectAsString({ Amount: 2400, Currency: 'INR' });
        case 45: // Russia
            return getMoneyObjectAsString({ Amount: 2500, Currency: 'RUB' });
        case 57: // China
            return getMoneyObjectAsString({ Amount: 200, Currency: 'CNY' });
        case 67: // Japan
            return getMoneyObjectAsString({ Amount: 4000, Currency: 'JPY' });
        case 39: // South Korea
            return getMoneyObjectAsString({ Amount: 40000, Currency: 'KRW' });

        // Default fallback
        default:
            return getMoneyObjectAsString({ Amount: 29, Currency: 'EUR' });
    }
}
